import React, { useEffect, useState } from 'react';
import './ContactPage.css';
import { apiGet, apiPost } from '../api';

const ContactPage = () => {
  const [email, setEmail] = useState('hello@example.com');
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const data = await apiGet('/api/contact', { locale: 'en' });
        if (!ignore && data?.email) setEmail(data.email);
      } catch (_) {}
    })();
    return () => { ignore = true; };
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    setSubmitting(true);
    try {
      await apiPost('/api/contact-requests', form);
      setMsg('Thanks! We will contact you soon.');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (_) {
      setMsg('Submission failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <section id="contact" className="section contact">
      <div className="container contact-wrap">
        <h2 className="contact-heading">Get In Touch</h2>
        <p className="contact-sub">Workshops, garden setups, collaborations — let's build healthy soil and homes together.</p>

        <div className="contact-modern">
          {/* Left: Info */}
          <div className="contact-info">
            <div className="contact-card">
              <div className="icon email" aria-hidden="true" />
              <div>
                <h3>Email</h3>
                <a className="contact-link" href={`mailto:${email}`}>{email}</a>
              </div>
            </div>
            <div className="contact-card">
              <div className="icon phone" aria-hidden="true" />
              <div>
                <h3>Phone</h3>
                <a className="contact-link" href="tel:+918138845709">+91 8138845709</a>
              </div>
            </div>
            <div className="contact-card">
              <div className="icon leaf" aria-hidden="true" />
              <div>
                <h3>Follow</h3>
                <div className="socials">
                  <a href="#" aria-label="Instagram">Instagram</a>
                  <a href="#" aria-label="YouTube">YouTube</a>
                  <a href="#" aria-label="Facebook">Facebook</a>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <form className="contact-form" onSubmit={onSubmit}>
            <div className="row">
              <input name="name" value={form.name} onChange={onChange} type="text" placeholder="Your name" required />
              <input name="email" value={form.email} onChange={onChange} type="email" placeholder="Your email" required />
            </div>
            <input name="subject" value={form.subject} onChange={onChange} type="text" placeholder="Subject" />
            <textarea name="message" value={form.message} onChange={onChange} rows="6" placeholder="Your message"></textarea>
            <button className="btn" type="submit" disabled={submitting}>{submitting ? 'Sending...' : 'Send Message'}</button>
            {msg && <div style={{ marginTop: 8 }}>{msg}</div>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
